export default __webpack_public_path__ + "static/prod5-3ee28a3a7efbf5209863cc282d1f21a0.jpg";